import axios from "@/util/axios";

const rfqUrl = `api/shopping/rfq`;

const getCacheBuster = () => Date.now().toString();

function modifyError(err) {
  delete err.request;
  delete err.response;
  delete err.config;
}

export const fetchRfq = async (id) => {
  try {
    const response = await axios.get(`${rfqUrl}/${encodeURIComponent(id)}?_=${getCacheBuster()}`);
    return response.data;
  } catch (err) {
    modifyError(err);
    throw err;
  }
};

export const createRfq = async () => {
  try {
    const response = await axios.post(`${rfqUrl}`);
    return response.data;
  } catch (err) {
    err.response = null;
    throw err;
  }
};

export const patchRfq = async (rfqId, data) => {
  try {
    const response = await axios.patch(`${rfqUrl}/${encodeURIComponent(rfqId)}`, data);
    return response.data;
  } catch (err) {
    modifyError(err);
    throw err;
  }
};

export const patchRfqPosition = async (rfqId, posId, data) => {
  try {
    const response = await axios.patch(`${rfqUrl}/${encodeURIComponent(rfqId)}/${encodeURIComponent(posId)}`, data);
    return response.data;
  } catch (err) {
    modifyError(err);
    throw err;
  }
};

export const submitRfq = async (rfqId, data) => {
  try {
    const response = await axios.post(`${rfqUrl}/${encodeURIComponent(rfqId)}/submit`, data);
    return response.data;
  } catch (err) {
    modifyError(err);
    throw err;
  }
};
